export enum MODAL_TYPES {
  WRONG_NETWORK_MODAL = 'WRONG_NETWORK_MODAL',
  ACCOUNT_MODAL = 'ACCOUNT_MODAL',
  CONNECT_WALLET_MODAL = 'CONNECT_WALLET_MODAL',
  CHAIN_MODAL = 'CHAIN_MODAL',
  BONDS_REDEEM_MODAL = 'BONDS_REDEEM_MODAL',
}

export const INITIAL_MODAL_STATE = {
  current: null,
  props: null,
};
